import { useContext, useState } from 'react';
import UserContext from '../../contexts/userContext';
import ErrorContext from "../../contexts/errorContext.js";

import { Wizard } from './1-1_Wizard';
import { MessageCard } from './1-2_MessageCard';

import { addConversation } from '../navigation/2-1_ConversationCards.jsx';

export const MessageList = () => {
    const { userContext, setUserContext, setAccount } = useContext(UserContext);
    const { setErrorContext } = useContext(ErrorContext);
    
    const conversation = userContext.conversation || {};
    const messages = conversation.messages || [];
    const numMesages = messages.length;

    const [ curConversationSize, setCurConversationSize ] = useState(0);
    const conversationSize = conversation.conversation_record_size;
    
    if (messages.length > 0 && (conversationSize !== curConversationSize)) {
        const maxSizeExceededDuringStreamedResponse = (conversation?.max_size_exceeded || []).filter(x => x).length > 0;
        if (conversationSize > 350000 || maxSizeExceededDuringStreamedResponse) {
            setErrorContext({
                title: 'Conversation too long',
                body: `Our conversation has gotten a bit long, and I'm starting to get confused.
                    Let's start a new conversation so I can best respond to your questions and commands.~~
                    If you want to chat about the same subject, you'll need to remind me of the context in our new conversation.`,
                manualClose: true,
                useTypewriter: true,
                size: 'lg',
                buttons: [{
                    variant:"secondary",
                    className:"a8-gray-background mx-1",
                    content: <><i className="bi-arrow-left" /> Back</>
                },{
                    variant:"primary",
                    className:"a8-dark-blue-background mx-2",
                    content: <><i className="bi-plus-circle" /> New Conversation</>,
                    onClick: () => addConversation(0, {userContext, setUserContext, setAccount})
                }]
            });
        }
        setCurConversationSize(conversationSize);
    }     

    if (messages.length === 0) {
        return <Wizard key={conversation.conversationid} />
    } else {
        return (
            <>
                {messages.map((message, messageIdx) => {
                    const history = messageIdx<=1 ? [] : messages 
                        .filter((message, i) => i<messageIdx)
                        .reduce((accumulator, message, i) => {
                            accumulator += i > 0 ? '\n' : '';
                            accumulator += message.type==='human' ? 'Human: ' : 'AI: ';
                            accumulator += (message.content || 0).trim();
                            return accumulator
                        }, '');

                    return <MessageCard
                        key={conversation.conversationid + messageIdx}
                        message={message}
                        messageIdx={messageIdx}
                        numMesages={numMesages}
                        history={history}
                    />
                })}
            </>
        )
    }
}